import styled from 'styled-components';

const MyDiv = styled.div`
  .card {
    background-color: #ffffff;
    border-radius: 12px;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100%;
  }

  .doc-container {
    background-color: #ffffff;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
  }

  .doc-image {
    width: 100%;
    max-height: 250px;
    object-fit: contain;
    margin-bottom: 12px;
  }

  .view-link {
    
    text-decoration: underline;
    align-self: end;
    cursor: pointer;
  }
`;

export default MyDiv;

